import React from 'react';
import { Helmet } from 'react-helmet-async';
import { clientContent } from '../../client/content';
import Section from '../../components/Section';
import CtaBlock from '../../components/CtaBlock';
import styles from './Faq.module.scss';

const Faq: React.FC = () => {
  const { title, description, canonical } = clientContent.seo.faq;
  const { title: pageTitle, subtitle, categories } = clientContent.faq;

  return (
    <div className={styles.faq} data-testid="faq-page">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
      </Helmet>

      {/* Page Header */}
      <section className="pageHeader">
        <div className="container">
          <span className="eyebrow">Common Questions</span>
          <h1>{pageTitle}</h1>
          <p>{subtitle}</p>
        </div>
      </section>

      {/* FAQ Anchor Links Directory */}
      <Section background="default">
        <div className={styles.faqDirectory}>
          <h2 className={styles.directoryHeading}>Quick Navigation</h2>
          <div className={styles.directoryGrid}>
            {categories.map((cat, catIndex) => (
              <div key={catIndex} className={styles.directoryCategory}>
                <h3>{cat.category}</h3>
                <ul>
                  {cat.items.map((item, index) => {
                    const qId = `q-${catIndex}-${index}`;
                    return (
                      <li key={index}>
                        <a href={`#${qId}`}>{item.question}</a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </Section>

      {/* FAQ Categories Section */}
      <Section background="surface">
        <div className={styles.faqContainer}>
          {categories.map((cat, catIndex) => (
            <div key={catIndex} className={styles.categorySection}>
              <h2 className={styles.categoryTitle}>{cat.category}</h2>
              <div className={styles.faqList}>
                {cat.items.map((item, index) => {
                  const qId = `q-${catIndex}-${index}`;
                  return (
                    <div key={index} id={qId} className={styles.faqItem}>
                      <h3>{item.question}</h3>
                      <p>{item.answer}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </Section>

      {/* Final Enquiry CTA */}
      <Section background="default">
        <CtaBlock
          title="Have another question?"
          subtitle="Get in touch directly and we will be happy to answer any questions about your project."
          buttonText="Get in Touch"
          buttonPath="/contact"
          secondaryButtonText="Explore Concepts"
          secondaryButtonPath="/concepts"
        />
      </Section>
    </div>
  );
};

export default Faq;
